import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const PivotTableSkeleton = ({ rows = 5, columns = 10 }) => {
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>
              <Skeleton width={60} />
            </th>
            {Array.from({ length: columns }).map((_, idx) => (
              <th key={idx} style={{ padding: "8px", border: "1px solid #ddd" }}>
                <Skeleton width={80} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx}>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                <Skeleton width={60} />
              </td>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <td key={colIdx} style={{ padding: "8px", border: "1px solid #ddd" }}>
                  <Skeleton />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PivotTableSkeleton;
